module.exports = __webpack_public_path__ + "static/media/emailconf.243af18a.png";